import { FreightHandlingUnitRowSchema } from "@redotech/redo-model/freight/freight-handling-unit";
import * as z from "zod/v4";

export const getFreightHandlingUnits = {
  name: "getFreightHandlingUnits" as const,
  input: z.object({}),
  output: z.object({ handlingUnits: z.array(FreightHandlingUnitRowSchema) }),
};
